import React, { useContext, useState } from "react";
import { AuthContext } from "../../services/AuthContext";
import axios from "axios";
import { toast } from "react-toastify";
import toastStyles from "../../styles/Toast.module.css";
import commentStyles from "../../styles/CommentInput.module.css";
import logo from "../../assets/logo_ciano_30_bianco.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";

function CommentInput({ postId, onCommentAdded }) {
  const { login } = useContext(AuthContext);
  const [comment, setComment] = useState("");

  const createComment = async (e) => {
    if (!comment.trim()) {
      toast.error("Scrivi un commento prima di inviare!");
      return;
    }

    try {
      const response = await axios.post(
        process.env.REACT_APP_SERVER_URL + "postsComments",
        {
          comment: comment,
          postId: postId,
        },
        {
          headers: {
            authToken: localStorage.getItem("AuthToken"),
          },
        }
      );
      setComment("");

      if (onCommentAdded) {
        onCommentAdded();
      }
    } catch (error) {
      toast.error("Errore durante la creazione del commento!");
      console.error(error);
    }
  };

  const showConfirmationToast = () => {
    toast(
      <div className={toastStyles.toastContainer}>
        <p className={toastStyles.logo}>
          <img src={logo} alt="" className={toastStyles.responsiveImage} />
          finstagram
        </p>

        <p className={"${toastStyles.toastContainer} ${toastStyles.text}"}>
          Vuoi inviare questo commento?
        </p>

        <div className={toastStyles.toastButtonContainer}>
          <button
            className={toastStyles.toastButton}
            onClick={() => {
              createComment();
              toast.dismiss(); // Nasconde il toast

              toast.success("Commento creato!", {
                autoClose: 5000,
                closeOnClick: false,
                className: toastStyles.toastSuccess,
                closeButton: ({ closeToast }) => (
                  <button
                    className={toastStyles.toastButton}
                    onClick={closeToast}
                  >
                    OK
                  </button>
                ),
              });
            }}
          >
            OK
          </button>
          <button
            className={toastStyles.toastButton}
            onClick={() => toast.dismiss()}
          >
            Annulla
          </button>
        </div>
      </div>,
      { autoClose: false, position: "top-center" }
    );
  };

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        if (!comment.trim()) {
          toast.error("Scrivi qualcosa prima di inviare!");
        } else {
          showConfirmationToast(); // Mostra la conferma personalizzata
        }
      }}
    >
      {/* <div className={commentStyles.comment}> */}
      <div className={commentStyles.textarea}>
        <textarea
          rows="3"
          // style={{ width: "100%" }}
          placeholder="Scrivi un commento..."
          value={comment}
          onChange={(e) => setComment(e.target.value)}
        />
      </div>
      <div className={toastStyles.button}>
        <button type="submit">
          <FontAwesomeIcon icon={faPaperPlane} />
        </button>
      </div>
      {/* </div> */}
    </form>
  );
}

export default CommentInput;
